import React from 'react';
import { Grid, Button, CircularProgress } from '@mui/material';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { withStyles } from '@mui/styles';
import CustomerDropdown from '../components/customer-dropdown';
import { SectionTitleStyled } from '../components/section-title';
import { INonDeliveryDaysProps, INonDeliveryDays } from './non-delivery-days.interface';
import WeekdayHeaderRow from './non-delivery-days-checkbox-header';
import WeekdayCheckboxRow from './non-delivery-days-checkbox-row';
import { WEEKDAYS, NON_DELIVERY_FIELDS } from './non-delivery-days.constants';
import { NonDeliveryDaysStyles } from './non-delivery-days.styles';

const NonDeliveryDaysManager = ({
  loading,
  selectedCustomerId,
  classes,
  setSelectedCustomerId,
  submitRequestNonDeliveryDays,
  nonDeliveryDays,
  handleCheckboxChange,
  hasAddUpdateNonDeliveryDaysPermission,
  isChanged,
}: INonDeliveryDaysProps): JSX.Element => {
  return (
    <>
      <SectionTitleStyled title="Customer Non Delivery Days Manager" />
      <Grid container direction="column" spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <CustomerDropdown
                isLabelOn
                isSelectedOption
                selectedCustomerId={selectedCustomerId}
                setSelectedCustomerId={customerId => setSelectedCustomerId(customerId)}
              />
            </Grid>
          </Grid>
        </Grid>
        {loading && !nonDeliveryDays ? (
          <Grid item>
            <CircularProgress />
          </Grid>
        ) : (
          <>
            {selectedCustomerId && selectedCustomerId !== 0 ? (
              <>
                <WeekdayHeaderRow />
                {NON_DELIVERY_FIELDS.map(({ key, label }, index) => {
                  const typedKey = key as keyof INonDeliveryDays;
                  const isLastItem = index === NON_DELIVERY_FIELDS.length - 1;
                  const daysArray =
                    nonDeliveryDays && typedKey in nonDeliveryDays
                      ? (nonDeliveryDays[typedKey] as string[]) || []
                      : [];

                  const onCheckboxChange = (selectedIdx: number, checked: boolean) => {
                    if (handleCheckboxChange) {
                      const day = WEEKDAYS[selectedIdx];
                      handleCheckboxChange(typedKey, day, checked);
                    }
                  };
                  return (
                    <React.Fragment key={key}>
                      <WeekdayCheckboxRow
                        title={label}
                        nonDeliveryDays={daysArray}
                        onChange={onCheckboxChange}
                        disabled={!hasAddUpdateNonDeliveryDaysPermission}
                      />
                      {isLastItem && (
                        <Grid
                          container
                          alignItems="center"
                          spacing={2}
                          className={classes.checkboxGrid}
                          style={{ marginTop: 32 }}
                        >
                          <Grid item xs={7} />
                          <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                              variant="contained"
                              color="primary"
                              id="saveNonDeliveryDaysButton"
                              type="button"
                              className={classes.saveButton}
                              onClick={submitRequestNonDeliveryDays}
                              disabled={
                                !selectedCustomerId ||
                                selectedCustomerId === 0 ||
                                !hasAddUpdateNonDeliveryDaysPermission ||
                                !isChanged
                              }
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </React.Fragment>
                  );
                })}
              </>
            ) : null}
          </>
        )}
      </Grid>
    </>
  );
};

export default withStyles(NonDeliveryDaysStyles)(NonDeliveryDaysManager);
